/* global jQuery */
import dropDownNavigationInit from './widgets/dropdown-navigation-widget.js';

(function ($) {

  /**
   * jQuery Plugin for the shopgate widget system
   * @param options
   * @requires $.fn.swiper
   * @see https://shopgate.atlassian.net/wiki/pages/viewpage.action?pageId=5145217
   */
  $.fn.shopgateWidgets = function (options) {
    var defaults = {
      blockSize: 100, // size of a block in the widget grid system [px]
      gridSize: 1200, // size of the widget grid system [px]
      /* Actually this settings object is outdated, since it came from a table
       * that should be removed by now (ShopWidgetSettings)
       * But it wasn't removed since there settings might come back in another way.
       */
      widgetSettings: {
        outer_margin: 0,
        widget_spacing: 0
      }
    };
    var isTablet = $('body').hasClass('tablet');
    var liveshoppingElementIndex = 0;
    const nowDate = new Date();

    options = $.extend(true, {}, defaults, options);

    if (typeof $.fn.swiper !== 'function') {
      console.error('swiper not loaded');
      return false;
    }

    return this.each(function () {

      var $widgetArea = $(this);
      var $rows = $widgetArea.find('.sg-widget-row');
      var $widgets = $rows.find('.sg-widget');

      _calcWidgetPositions(false);

      $(window).bind('orientationchange resize', function () {
        _calcWidgetPositions(true);
      });

      // inti image slider
      $widgets.find('.js-widget-image-slider').each(function (index) {
        var defaultDelay = 4000; // in ms
        var $this = $(this);
        var widgetData = $this.data();
        var widgetDelay = widgetData.delay;
        var autoplay = false;

        // check for autoplay and its delay
        if (widgetData.autostart) {
          if (
            widgetDelay !== null
            && widgetDelay !== undefined
            && widgetDelay !== ''
            && widgetDelay != 0
          ) {
            autoplay = widgetDelay;
          } else {
            autoplay = defaultDelay;
          }
        }

        // autoinit all widget-swipers
        $this.addClass('widget-slider-' + index).swiper({
          pagination: '.widget-slider-' + index + ' .pagination',
          createPagination: widgetData.pagination,
          paginationClickable: true,
          loop: widgetData.loop,
          calculateHeight: true,
          autoplay: autoplay,
          resizeReInit: true
        });
      });

      $widgets.filter('.sg-widget-category-list').each(function () {

        // makes the headline-Divider touchable to toggle categories
        $('.collapse-on-init .divider').unbind('click').on('click', function () {
          var that = $(this).parent('.collapse-on-init');
          $('.js-category-img').trigger('unveil');

          if (that.hasClass('collapsed')) {
            that.removeClass('collapsed').addClass('uncollapsed');
          } else if (that.hasClass('uncollapsed')) {
            that.removeClass('uncollapsed').addClass('collapsed');
          }
        });

        /* if second category level is activated
         * the toogle button is touchable and opens the childcategories
         */
        $('.first-level.is-parent .toggle').unbind('click').on('click', function () {
          event.preventDefault();
          event.stopPropagation();

          var that = $(this).parent('.is-parent');
          var those = that.nextUntil('.first-level');

          if (that.hasClass('collapsed')) {
            that.removeClass('collapsed').addClass('uncollapsed');
            those.removeClass('collapsed').addClass('uncollapsed');
          } else if (that.hasClass('uncollapsed')) {
            that.removeClass('uncollapsed').addClass('collapsed');
            those.removeClass('uncollapsed').addClass('collapsed');
          }
        });
      });

      // init product slider
      $widgets.find('.js-widget-product-slider').each(function (index) {
        var defaultDelay = 4000; // in ms
        var $this = $(this);
        var widgetData = $this.parent().data();
        var widgetDelay = widgetData.delay;
        var autoplay = false;

        // check for autoplay and its delay
        if (widgetData.autostart) {
          if (widgetDelay !== null && widgetDelay !== undefined && widgetDelay !== '' && widgetDelay != 0) {
            autoplay = widgetDelay;
          } else {
            autoplay = defaultDelay;
          }
        }

        // autoinit all widget-swipers
        $this.addClass('widget-slider-product-' + index);
        $.shopgate.sanitizeAndInitSwiper(
          window.Swiper,
          $this,
          {
            slidesPerView: 'auto',
            loop: widgetData.loop,
            grabCursor: true,
            watchActiveIndex: true,
            centeredSlides: true,
            resizeReInit: true,
            autoplay: autoplay,
            visibilityFullFit: true,
            calculateHeight: true
        }
        );
      });

      // Widget product-list
      $widgets.filter('.sg-widget-product-list').each(function () {
        var $this = $(this);
        var $productList = $this.find('.product-list');
        var $moreButton = $this.find('.product-list-more');
        var widgetSettings = $this.data('widgetSettings');
        var currentPage = 1;

        // Init equal height calculation
        $(document).ready(function () {
          $productList.responsiveEqualHeightGrid('init', {
            children: ['.product-title', '.rating', '.price-box'],
            itemSelector: '.single-product'
          });
        });

        $moreButton.click(loadMoreProducts);

        /**
         * Load more products and insert into widget
         *
         * @param {string} event
         */
        function loadMoreProducts(event) {
          event.preventDefault();

          var nextPage = currentPage + 1;

          // Create container and append to list
          var $newPage = $(
            '<div>',
            { 'class': 'product-list-pages product-list-page-' + nextPage }
          );
          $productList.append($newPage);

          // Start ajax request
          $.shopgate.ajaxContentUpdate({
            url: options.urlGetProducts + '?page=' + nextPage,
            type: 'POST',
            data: {
              'widget_settings': JSON.stringify(widgetSettings)
            },
            targetSelector: $newPage,
            success: productsLoaded
          });
        }

        /**
         * Things to be done when product list was updated
         *
         * @param data
         * @param textStatus
         * @param jqXHR
         */
        function productsLoaded(data, textStatus, jqXHR) {
          // Update page counter
          currentPage++;

          // Fire events especially to update equal height calculation
          $(document).trigger('shopgateFramework.ui.productListUpdated', [function () {

            $(document).trigger('shopgateFramework.ui.contentUpdated', [$productList]);
          }]);

          // Hide more-button if there are no more products
          if (data.data.pagination.controls.next.disabled) {
            $moreButton.hide();
          }
        }
      });

      $widgets
        .filter('.js-widget-liveshopping')
        .find('.liveshopping-swiper')
        .each(function (index, el) {
          var $liveshoppingElement = $(el);
          var slideCounter = $liveshoppingElement.find('.swiper-slide').length;
          let swiper = {};
          if (isTablet) {
            if (slideCounter > 1) {
              swiper = _initSwiper();
            }
          } else {
            swiper = _initSwiper();
          }

          // must be initialized after the swiper is initialized
          $liveshoppingElement.find('.swiper-slide').shopgateLiveshopping({
            swiper,
            isTablet,
          });

          liveshoppingElementIndex++;

          function _initSwiper() {
            $liveshoppingElement
              .next('.liveshopping-swiper-pagination')
              .addClass('pagination-index-' + liveshoppingElementIndex);

            var swiperOptions = {
              pagination: '.liveshopping-swiper-pagination.pagination-index-' + liveshoppingElementIndex,
              loop: false,
              noSwiping: false,
              grabCursor: true,
              paginationClickable: true,
              calculateHeight: true,
              slidesPerView: 1,
              slidesPerGroup: 1,
              loopAdditionalSlides: 0
            };

            if (isTablet) {
              swiperOptions.slidesPerView = 2;
              swiperOptions.slidesPerGroup = 2;
              swiperOptions.createPagination = slideCounter > 2;
              swiperOptions.onSwiperCreated = function () {
                $liveshoppingElement.responsiveEqualHeightGrid('init', {
                  children: ['.title', '.product-info'],
                  itemSelector: '.content-slide'
                });
              }
            } else {
              swiperOptions.createPagination = slideCounter > 1;
              swiperOptions.noSwiping = slideCounter <= 1;
            }

            return $liveshoppingElement.swiper(swiperOptions);
          }
        });

      $widgets
        .filter('.sg-widget-dropdown-navigation')
        .each((index, container) => {
          dropDownNavigationInit(container);
        });
      /*
       * Html widget YouTube iframes preparation
       */
      _prepareYouTubeIframes($widgets.filter('.sg-widget-html'));

      /**
       * Takes care all YouTube iframes in given jquery element has
       * jsapi enabled and are paused when app goes to background or
       * viewDidDisappear.
       *
       * @param {jQuery} $element - jquery element with or without iframe as child
       * @private
       */
      function _prepareYouTubeIframes($element) {
        // find youtube iframes
        var $youtubeIframes = $element.find('iframe[src*="youtube.com"]');

        if (!$youtubeIframes.length) {
          return;
        }
        // make sure apijs is enabled
        $youtubeIframes.each(function () {
          var $iframe = $(this);
          var src = $iframe.attr('src');
          var srcLink = new window.SGLink(src);
          if (!srcLink.getParam('enablejsapi')) {
            srcLink.setParam('enablejsapi', 1);
            $iframe.attr('src', srcLink.toString());
          }
        });

        // taking care about youtube iframes works as expected on appDidEnterBackground
        window.SGEvent.Broadcast.register('applicationDidEnterBackground');
        window.SGEvent.registerCallback(
          'viewDidDisappear, applicationDidEnterBackground',
          function () {
            if (window.SGAction.debug) {
              console.log('Stopping youtube iframes.');
            }
            var cmd = '{"event":"command","func":"pauseVideo","args":""}';
            $youtubeIframes.each(function () {
              if ('contentWindow' in this && 'postMessage' in this.contentWindow) {
                this.contentWindow.postMessage(cmd, '*');
              }
            });
          });
      }

      /**
       * Check the published and schedule states of the widget and perform
       * necessary operations to hide the widget
       * @param {Object} setting - widget settings
       * @return {boolean} hide widget or don't hide widget
       */
      function shouldHideWidget(setting) {
        // Show widget if flag does not exist (old widgets)
        if (!setting.hasOwnProperty('published')) {
          return false;
        }

        if (!setting.published) {
          return true;
        }

        if (setting.hasOwnProperty('plan') && setting.plan) {
          let startDate = null;
          let endDate = null;
          let notStartedYet = false;
          let finishedAlready = false;

          if (setting.planDate.valid_from) {
            startDate = new Date(setting.planDate.valid_from);
            notStartedYet = nowDate <= startDate;
          }

          if (setting.planDate.valid_to) {
            endDate = new Date(setting.planDate.valid_to);
            finishedAlready = nowDate >= endDate;
          }

          // Don't hide if no dates found
          if (!startDate && !endDate) {
            return false;
          }

          // Hide if some wrong dates are passed
          if (startDate && endDate && (startDate >= endDate)) {
            return true;
          }

          // Hide if start date is set but it is not there yet
          // Hide if end date is reached
          if ((startDate && notStartedYet) || (endDate && finishedAlready)) {
            return true;
          }
        }

        return false;
      }

      /**
       * Calculate the position and size for every widget
       *
       * @param {boolean} reinit Tells if the function was called during a reinitialization
       *  of the widgets, which can for example happen during an orientation change.
       * @private
       */
      function _calcWidgetPositions(reinit) {
        // Reset margin before calculation
        $widgetArea.css('margin', 0);

        const fullWidth = $widgetArea.width();
        const margin = (options.widgetSettings.outer_margin / options.gridSize) * fullWidth;
        const padding = (options.widgetSettings.widget_spacing / options.gridSize) * fullWidth;
        const usableWidth = fullWidth + padding - (2 * margin);
        const blockSize = usableWidth / (options.gridSize / options.blockSize);
        let maxBlocksY = 0;

        $widgetArea.css('margin', Math.round(margin - (padding / 2)));

        $widgets.each(function () {
          const $widget = $(this);
          const widgetData = $widget.data();
          const sizeX = widgetData.sizeX;
          const sizeY = widgetData.sizeY;
          const row = widgetData.row;
          const col = widgetData.col;
          const setting = widgetData.widgetSettings;

          if (setting) {
            if (shouldHideWidget(setting)) {
              $widget.addClass('sg-widget-varheight').hide();
            }
          }

          if (row + sizeY > maxBlocksY) {
            maxBlocksY = row + sizeY;
          }

          /*
           If there are only var-height elements in the row, we mark the parent widget as var-height
           */
          if (
            $widget.hasClass('sg-widget-varheight')
            && $widget.siblings().not('.sg-widget-varheight').length === 0
          ) {
            $widget.parent().addClass('sg-widget-row-varheight has-separator');
            $widget.css({
              'border-width': (padding / 2),
            });
          } else {
            $widget.css({
              width: (sizeX * blockSize),
              height: (sizeY * blockSize),
              left: ((col - 1) * blockSize),
              'border-width': (padding / 2),
            });
          }

          // For image widgets define if image should be sized to width or height
          if ($widget.hasClass('sg-widget-image') && !reinit) {
            if (sizeX >= sizeY) {
              $widget.find('img').css('width', '100%');
            } else {
              $widget.find('img').css('height', '100%');
            }
          }
        });

        $rows.each(function () {
          const $row = $(this);
          const $nextRow = $row.next();
          let rowBlocks = 1;

          if ($row.hasClass('sg-widget-row-varheight')) {
            if ($row.children(':visible').length === 0) {
              $row.hide();
            }

            return;
          }

          if ($nextRow.length) {
            rowBlocks = $nextRow.data('row') - $row.data('row');
          } else {
            rowBlocks = maxBlocksY - $row.data('row');
          }

          $row.height((rowBlocks * blockSize));
        });
      }
    });
  };
})(jQuery);




// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-widgets.js